import { render, staticRenderFns } from "./FormModals.vue?vue&type=template&id=ab860732&scoped=true&"
import script from "./FormModals.vue?vue&type=script&lang=js&"
export * from "./FormModals.vue?vue&type=script&lang=js&"
import style0 from "./FormModals.vue?vue&type=style&index=0&id=ab860732&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab860732",
  null
  
)

export default component.exports